import React from 'react';
import { MainDiv, LeftDiv, RightDiv } from './styles';
import { observer } from 'mobx-react-lite';
import CustomerFilesLoading from './customerFilesLoading';
import ProjectsLoading from './projectsLoading';
import InvoicesLoading from './InvoicesLoading';
import MembersLoading from './membersLoading';
import AdditionalInfoLoading from './additionalInfoLoading';

const CustomerDetailLoading: React.FC = () => {
  return (
    <MainDiv>
      <LeftDiv>
        <CustomerFilesLoading />
        <ProjectsLoading />
        <CustomerFilesLoading />
        <InvoicesLoading />
      </LeftDiv>
      <RightDiv>
        <MembersLoading />
        <AdditionalInfoLoading />
      </RightDiv>
    </MainDiv>
  );
};

export default observer(CustomerDetailLoading);
